import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=583baa4e&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=ts"
export * from "./Administration.vue?vue&type=script&lang=ts"
import style0 from "./Administration.vue?vue&type=style&index=0&id=583baa4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583baa4e",
  null
  
)

export default component.exports